import { BaseTockAction } from './ToastActions';
import { SharedAppConstants } from '@tock/shared-app-constants';
import { v4 as uuidv4 } from 'uuid';

type State = Toast[];
export interface Toast {
  type?: 'error' | 'info';
  message: string | JSX.Element;
  linkText?: string;
  onClickLink?(): void;
  onClear?: () => void;
  id: string;
}

export function reducer(state: State = [], action: BaseTockAction): State {
  const { type, toastMessage } = action;
  if (type === SharedAppConstants.CLEAR_TOAST) {
    return [];
  }

  if (type === SharedAppConstants.REMOVE_TOAST) {
    return state.filter((t) => t.id !== action.payload.id);
  }

  if (!toastMessage) {
    return state;
  }

  // early return to avoid displaying multiple instances of the same toast
  if (state.some((t) => t.message === toastMessage.message)) {
    return state;
  }

  switch (toastMessage.type) {
    case 'info':
    case 'error': {
      return [
        ...state,
        {
          ...toastMessage,
          id: toastMessage.id ?? uuidv4(),
          onClear: toastMessage.onClear,
        },
      ];
    }
    default:
      return state;
  }
}
